import { render, staticRenderFns } from "./bit-performance.vue?vue&type=template&id=7388def8"
import script from "./bit-performance.vue?vue&type=script&lang=js"
export * from "./bit-performance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports